import React, { useEffect, useMemo } from 'react';
import {
  convertToLocaleFormat,
  format_locale_date_ind,
} from '../../../Constants/B2G1CategoryPage';
import { getScreenName } from '../../../Utils/helper';
import GeneralItemMarquee from '../../StoreHomePage/GeneralItemMarquee';
import { liveDataMarquee } from './constant';
import {
  BabyBumpsSafeText,
  CDLiveCountSection,
  Comma,
  CountNumber,
  CountNumberDiv,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function CDPageLiveCount({
  pageLiveCountValue,
  changedIndexes,
  description,
  liveCountRef,
  happyTuesday,
  textColor,
  textBackground,
  category,
  heading,
  lactoMama,
  subHead,
  tabThemeColor
}) {
  const liveCountValue = convertToLocaleFormat(
    pageLiveCountValue,
    format_locale_date_ind,
  );
  useEffect(() => {
    fireEvent({
      category: 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: 'Live Count Section',
      shape: 'Carousel',
      page_url: window.location.href.slice(0, 99),
    });
  }, []);
  const marqueeData = useMemo(() => liveDataMarquee(), []);

  return (
    <CDLiveCountSection ref={liveCountRef} category={category} tabThemeColor={tabThemeColor} lactoMama={lactoMama}>
      {heading ? (
        <p className="heading">
          {heading}
          <span>{subHead}</span>
        </p>
      ) : null}
      <CountNumberDiv lactoMama={lactoMama} happyTuesday={happyTuesday}>
        {liveCountValue.split('')?.map((num, index) => {
          if (num == ',')
            return (
              <Comma key={num + '-' + index} color={textBackground}>
                ,
              </Comma>
            );
          return (
            <CountNumber
              className={
                changedIndexes.includes(index) ? 'numberAnimation' : ''
              }
              key={num + '-' + index}
              textBackground={textBackground}
              textColor={textColor}
            >
              <span>{num}</span>
            </CountNumber>
          );
        })}
      </CountNumberDiv>
      <BabyBumpsSafeText lactoMama={lactoMama}>{description}</BabyBumpsSafeText>
      {!happyTuesday && !textColor ? (
        <GeneralItemMarquee marqueeData={marqueeData} clothDiaper={true} />
      ) : null}
    </CDLiveCountSection>
  );
}
